import TableError from "./error"

function TableIsRunningError({ method, message }) {
  TableError.call(this, `[${method}]: ${message}`)
  this.name = "TableIsRunningError"
  this.method = method
}

TableIsRunningError.prototype = Object.create(TableError.prototype)
TableIsRunningError.prototype.constructor = TableIsRunningError

export default TableIsRunningError
